import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showLoadindicator: true,
    dataLoadError: null,
    cmsData: null,
    player: {
      currentTime: 0,
      currentTrackId: 'neerach',
      isPlaying: false
    },
    stationStartTimestamp: null,
    stationEndTimestamp: null,
    clickCount: 0,
    screenState: 'player',
    visitorId: null,
    lang: null,
    lastHttpAction: null,
  },
  actions,
  getters,
  mutations,
});